import { GetQuoteActivityModel } from "@factory/model/query-model-quote-activity";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { quoteActivityFormDefault } from "./form.default";
import { QuoteActivityFormSchema } from "./form.rule";

export const useFormDefaultQuoteActivity = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetQuoteActivityModel | undefined) => {
    return !cachedValue
      ? quoteActivityFormDefault
      : ({
          code: cachedValue.code,
          baseActivity: cachedValue.base_activity,
          quotation: cachedValue.quotation,
          isModified: Boolean(cachedValue.is_modified),
          name: cachedValue.name,
          description: cachedValue.description,
          day: cachedValue.day,
          isChildActivity: Boolean(cachedValue.is_child_activity),
          childRate: cachedValue.child_rate,
          showAsOptional: Boolean(cachedValue.show_as_optional),
          isFree: Boolean(cachedValue.is_free),
          entranceFee: cachedValue.entrance_fee,
          numPeople: cachedValue.num_people,
          unit: cachedValue.unit,
          ratePerPax: cachedValue.rate_per_pax,
          amount: cachedValue.amount,
        } as QuoteActivityFormSchema);
  };

  return {
    getDefault,
  };
};
